<template>
  <tw-layout-section id="cookie-declaration">
    <tw-layout-single-column size="l">
      <script-wrap
        id="CookieDeclaration"
        :src="`https://consent.cookiebot.com/${cookiebotId}/cd.js`"
      />
    </tw-layout-single-column>
  </tw-layout-section>
</template>

<script setup>
const cookiebotId = '3ee0fcac-70db-45fa-a963-5030d565d02d';
</script>
